import React from 'react';
import './styles.css';

const Card = ({
  children,
  className = '',
  animation = '',
  isPill = false,
  noHover = false,
  style = {}
}) => {
  const cardClasses = [
    'custom-card',
    isPill ? 'pill-card' : '',
    noHover ? 'no-hover' : '',
    animation,
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={cardClasses} style={style}>
      {children}
    </div>
  );
};

export default Card;
